import Api from '../../api/Api'

const blog = {
    namespaced: true,

    state: {
    },

    mutations: {
    },

    actions: {
        // Public
        fetchBlogs({ commit }, param) {
            return new Promise((resolve, reject) => {
                let url = `/artikel/public?page=${param.page || 1}&per_page=${param.per_page || 10}`
                if (param.search) url += `&search=${param.search}`
                if (param.kategori) url += `&kategori=${param.kategori}`
                Api.get(url)
                    .then(response => {
                        commit('')
                        resolve(response.data)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },

        fetchBlogBySlug({ commit }, slug) {
            return new Promise((resolve, reject) => {
                Api.get(`/artikel/public/${slug}`)
                    .then(response => {
                        commit('')
                        resolve(response.data)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },

        fetchCategories({ commit }) {
            return new Promise((resolve, reject) => {
                Api.get(`/artikel/kategori`)
                    .then(response => {
                        commit('')
                        resolve(response.data)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },

        fetchAuthor({ commit }, slug) {
            return new Promise((resolve, reject) => {
                Api.get(`/penulis/${slug}`)
                    .then(response => {
                        commit('')
                        resolve(response.data)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },

        // Admin
        fetchAdminBlogs({ commit }, param) {
            return new Promise((resolve, reject) => {
                let url = `/artikel?page=${param.page || 1}&per_page=${param.per_page || 10}`
                if (param.search) url += `&search=${param.search}`
                Api.get(url)
                    .then(response => {
                        commit('')
                        resolve(response.data)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },

        fetchBlogDetail({ commit }, id) {
            return new Promise((resolve, reject) => {
                Api.get(`/artikel/detail/${id}`)
                    .then(response => {
                        commit('')
                        resolve(response.data)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },

        createBlog({ commit }, param) {
            return new Promise((resolve, reject) => {
                Api.post(`/artikel`, param)
                    .then(response => {
                        commit('')
                        resolve(response)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },

        updateBlog({ commit }, param) {
            return new Promise((resolve, reject) => {
                Api.post(`/artikel/update/${param.id}`, param.data)
                    .then(response => {
                        commit('')
                        resolve(response)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },

        deleteBlog({ commit }, id) {
            return new Promise((resolve, reject) => {
                Api.post(`/artikel/delete/${id}`)
                    .then(response => {
                        commit('')
                        resolve(response.data)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },

        createCategory({ commit }, param) {
            return new Promise((resolve, reject) => {
                Api.post(`/artikel/kategori`, param)
                    .then(response => {
                        commit('')
                        resolve(response)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },

        deleteCategory({ commit }, id) {
            return new Promise((resolve, reject) => {
                Api.post(`/artikel/kategori/delete/${id}`)
                    .then(response => {
                        commit('')
                        resolve(response.data)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
    },

    getters: {
    }
}

export default blog
